import React, { useEffect, useState } from 'react';
import { homeService } from '../../services/homeService';

function fiveStarWithText(reviews) {
  return (reviews || []).filter((review) => review.rating === 5 && (review.review_text || '').trim());
}

function byNewest(a, b) {
  const aTime = new Date(a.created_at || 0).getTime();
  const bTime = new Date(b.created_at || 0).getTime();
  return bTime - aTime;
}

export function usePublicReviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    homeService.getPublicReviews().then((dbReviews) => {
      setReviews(fiveStarWithText(dbReviews).sort(byNewest));
    }).catch(() => {});
  }, []);

  return reviews;
}

const Testimonials = ({ reviews }) => reviews.length === 0 ? null : (
  <section className="section testimonials">
    <h2>What People Are Saying</h2>
    <div className="testimonials-grid">
      {reviews.slice(0, 3).map((review, i) => (
        <div className="testimonial-card" key={`${review.display_name}-${i}`}>
          <div className="testimonial-stars">
            {'★'.repeat(5)}
          </div>
          {review.review_text ? (
            <p className="testimonial-quote">"{review.review_text}"</p>
          ) : null}
          <cite>{review.display_name}</cite>
        </div>
      ))}
    </div>
  </section>
);

export default Testimonials;
